export const defaultButtonStyle = {
  fontSize: '0.875rem',
  padding: '0.2rem 1.4rem',
  borderRadius: 'full',
  border: '1px solid #232323',
  backgroundColor: '#232323',
  color: '#FFFFFF',
  ':focus': {
    boxShadow: 'none',
  },
}

export const defaultDarkModeButtonStyle = {
  fontSize: '0.875rem',
  padding: '0.2rem 1.4rem',
  borderRadius: 'full',
  border: '1px solid #fcfcfc',
  backgroundColor: '#fcfcfc',
  color: '#232323',
  ':focus': {
    boxShadow: 'none',
  },
}

export const smallButtonStyle = {
  height: 'auto',
  fontSize: '0.75rem',
  padding: '0.5rem 1rem',
  borderRadius: '100px',
}
